import { Link } from 'react-router-dom';

type EmptyStateProps = {
  title: string;
  description: string;
  icon?: string;
  actionLabel?: string;
  actionTo?: string;
};

export function EmptyState({
  title,
  description,
  icon = 'pi pi-search',
  actionLabel,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="state-card" role="status">
      <i className={icon} aria-hidden="true" />
      <h2>{title}</h2>
      <p>{description}</p>
      {actionLabel && actionTo && (
        <Link className="button-link button-link--primary" to={actionTo}>
          {actionLabel}
        </Link>
      )}
    </div>
  );
}
